import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "../SchedulingStyles/PatientSearch.css";
import FormatUrl from "../../../utils/UrlFormatter"; 

const PatientSearch = ({ onSelect, clinicId, csrfToken, resetTrigger }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState("");
  const [patients, setPatients] = useState([]);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    const fetchPatients = async () => {
      if (!clinicId || !csrfToken) return;
      setLoading(true);

      try {
        const response = await fetch(
          FormatUrl(`/get-patients/?clinic_id=${clinicId}`),
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": csrfToken,
            },
            credentials: "include",
          }
        );

        const data = await response.json();

        if (data.status === "success" && Array.isArray(data.patients)) {
          const formatted = data.patients.map((p) => ({
            id: p.id,
            name: `${p.firstName} ${p.lastName}`,
            email: p.email,
            phone: p.phone,
          }));
          setPatients(formatted);
          setNoData(formatted.length === 0);
        } else {
          setNoData(true);
          setPatients([]);
        }
      } catch (error) {
        console.error("Error fetching patients:", error);
        setNoData(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPatients();
  }, [clinicId, csrfToken]);

  useEffect(() => {
    setQuery("");
    setFilteredPatients([]);
    onSelect(null);
  }, [resetTrigger, onSelect]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
    const results = patients.filter((p) =>
      p.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredPatients(results);
  };

  return (
    <div className="patient-search-container">
      <label htmlFor="patient-search">{t("admin_scheduling_new.search_label")}</label>
      <input
        type="text"
        id="patient-search"
        placeholder={t("admin_scheduling_new.search_placeholder")}
        value={query}
        onChange={handleSearch}
        disabled={loading || noData}
      />

      {loading && <p className="loading-text">{t("admin_scheduling_new.loading_text")}</p>}

      {!loading && noData && (
        <p className="no-data-text">{t("admin_scheduling_new.no_data_text")}</p>
      )}

      {filteredPatients.length > 0 && (
        <ul className="patient-list">
          {filteredPatients.map((patient) => (
            <li
              key={patient.id}
              onClick={() => {
                onSelect(patient);
                setQuery(patient.name);
                setFilteredPatients([]);
              }}
            >
              {patient.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PatientSearch;
